export default class ApiUrls {
  static getPropertyDataUrl(id) {
    let q;
    if (process.env.VUE_APP_ENV === 'prod') {
      q = 'https://prod-api.yeah.ki-group.jp/real-estate-properties/';
    } else {
      q = 'https://stg-api.yeah.ki-group.jp/real-estate-properties/';
    }
    q += id;
    return q;
  }

  static getExtraPropertyDataUrl(id) {
    return `https://homehouse.ki-group.jp/jp_include/index2.php?n=${id}`;
  }

  static getPrefectureListUrl(n, kindLaw) {
    let q = '';
    if (n === 1) {
      let kind = '';
      if (kindLaw === 'newly-house' || kindLaw === 1) {
        kind = 1;
      } else if (kindLaw === 'second-hand-house' || kindLaw === 2) {
        kind = 2;
      } else {
        kind = 0;
      }
      if (process.env.VUE_APP_ENV === 'prod') {
        // q = `https://gjdxv7pkq4.execute-api.ap-northeast-1.amazonaws.com/default/getPrefectureList?kind=${kind}`;
        q = `https://lcoxiz1vhi.execute-api.ap-northeast-1.amazonaws.com/default/getPrefectureList?kind=${kind}`;
      } else {
        q = `https://jaur6xhxi4.execute-api.ap-northeast-1.amazonaws.com/default/getPrefectureListDev?kind=${kind}`;
      }
    } else {
      q = 'https://open-data.iemarco.jp/api/v1/prefectures';
    }
    return q;
  }

  static getCityListUrl(n, cd, kindLaw) {
    let q = '';
    if (n === 1) {
      let kind = '';
      if (kindLaw === 'newly-house' || kindLaw === 1) {
        kind = 1;
      } else if (kindLaw === 'second-hand-house' || kindLaw === 2) {
        kind = 2;
      } else {
        kind = 0;
      }
      if (process.env.VUE_APP_ENV === 'prod') {
        q = `https://5a6soo2ozi.execute-api.ap-northeast-1.amazonaws.com/default/getCityList?pref_code=${cd}&kind=${kind}`;
      } else {
        q = `https://mujl8gxzjl.execute-api.ap-northeast-1.amazonaws.com/default/getCityListDev?pref_code=${cd}&kind=${kind}`;
      }
    } else {
      q = `https://open-data.iemarco.jp/api/v1/cities?pref_code=${cd}`;
    }
    return q;
  }

  static getTownListUrl(n, cd, kindLaw) {
    let q = '';
    if (n === 1) {
      let kind = '';
      if (kindLaw === 'newly-house' || kindLaw === 1) {
        kind = 1;
      } else if (kindLaw === 'second-hand-house' || kindLaw === 2) {
        kind = 2;
      } else {
        kind = 0;
      }
      if (process.env.VUE_APP_ENV === 'prod') {
        q = `https://l8aa0zzeci.execute-api.ap-northeast-1.amazonaws.com/default/getTownList?city_code=${cd}&kind=${kind}`;
      } else {
        q = `https://s00okafv54.execute-api.ap-northeast-1.amazonaws.com/default/getTownListDev?city_code=${cd}&kind=${kind}`;
      }
    } else {
      q = `https://open-data.iemarco.jp/api/v1/towns?city_code=${cd}`;
    }
    return q;
  }

  static getJuniorHighSchoolsUrl(name, pref, city) {
    return `https://1v1jgafxb2.execute-api.ap-northeast-1.amazonaws.com/production/api/v1/junior-high-schools?name=${name}&prefecture=${pref}&establishmentbody=${city}`;
  }

  static getElementarySchoolsUrl(name, pref, city) {
    return `https://1v1jgafxb2.execute-api.ap-northeast-1.amazonaws.com/production/api/v1/elementary-schools?name=${name}&prefecture=${pref}&establishmentbody=${city}`;
  }

  static getJuniorHighSchoolDistrictsUrl(lat, lng) {
    return `https://1v1jgafxb2.execute-api.ap-northeast-1.amazonaws.com/production/api/v1/junior-high-school-districts?lat=${lat}&lng=${lng}&radius=10`;
  }

  static getElementarySchoolDistrictsUrl(lat, lng) {
    return `https://1v1jgafxb2.execute-api.ap-northeast-1.amazonaws.com/production/api/v1/elementary-school-districts?lat=${lat}&lng=${lng}&radius=10`;
  }

  static getAreaRPListUrl(pref, city) {
    return `https://ki-group.microcms.io/api/v1/areainfo?filters=prefid[equals]${pref}[and]cityid[equals]${city}`;
  }

  static getMypageInfoListUrl(limit) {
    let Uri = 'https://ki-group.microcms.io/api/v1/mypageinfo?filters=isDisplay[equals]true';
    if (limit > 0) Uri += `&limit=${limit}`;
    return Uri;
  }

  static getSuggestListUrl(limit) {
    let Uri = 'https://ki-group.microcms.io/api/v1/snipet?filters=isDisplay[equals]true';
    if (limit > 0) Uri += `&limit=${limit}`;
    return Uri;
  }

  static getBlogListUrl(cat, limit) {
    let Uri = 'https://ki-group.microcms.io/api/v1/blog';
    Uri += `?limit=${limit}`;
    if (cat !== 0) Uri += `&filters=category[equals]${cat}`;
    return Uri;
  }
  static getRPListUrl(cat) {
    let Uri = 'https://ki-group.microcms.io/api/v1/advertisement';
    Uri += `?filters=cityid[equals]${cat}`;
    return Uri;
  }
  static getModifiableTextListUrl() {
    return 'https://ki-group.microcms.io/api/v1/inserttexts';
  }
  static getCityAverageUrl(cd, param) {
    let q;
    if (process.env.VUE_APP_ENV === 'prod') {
      q = `https://prod-api.yeah.ki-group.jp/cities/${cd}/`;
    } else {
      q = `https://stg-api.yeah.ki-group.jp/cities/${cd}/`;
    }

    const url = new URL(q);
    const params = new URLSearchParams(param);
    url.search = params;

    return url.href;
  }
}
